<script setup lang="ts">
import { accordionItems, contact, defaultValue, footerCopy, links } from './data'
import type { LinkCategory, LinkItem } from './interface'

const { sendEvent } = useSendEvent()

function sendFormGa(link: LinkCategory | LinkItem) {
    sendEvent({
        category: 'lp-homepage_footer',
        label: `${link.name}`,
        click_text: `${link.name}`,
        click_element: 'text',
        component_name: 'footer',
    })
}

function sendClientZoneGa(link: string) {
    sendEvent({
        category: 'lp-homepage_footer',
        label: `${link}`,
        click_text: `${link}`,
        click_element: 'link',
        component_name: 'footer',
    })
}

function sendChildGa(item: LinkItem, link: string) {
    sendEvent({
        category: 'lp-homepage_footer',
        label: `${link} > ${item.name}`,
        click_text: `${link} > ${item.name}`,
        click_path: `${item.link}`,
        click_element: 'link',
        component_name: 'footer',
    })
}
</script>

<template>
    <footer class="bg-plus-lp-dark-blue pb-6">
        <div class="plus-lp-container mx-auto block pt-24 text-white">
            <div class="flex flex-col gap-8 pb-6 xl:flex-row xl:gap-6">
                <PlusBlogLpMoleculeFormFooterForm />
                <PlusBlogLpMoleculeIPlus />
            </div>
            <div class="flex flex-col gap-6 pb-8 xl:flex-row xl:pb-6 xl:pt-[72px]">
                <PlusBlogLpAtomAccordion
                    type="single"
                    class="w-full xl:hidden"
                    collapsible
                    :default-value="defaultValue"
                >
                    <PlusBlogLpAtomAccordionItem
                        v-for="item in accordionItems"
                        :key="item.value"
                        :value="item.value"
                    >
                        <PlusBlogLpAtomAccordionTrigger>
                            <span
                                class="text-heading-xs py-4 font-figtree font-bold"
                                @click="sendClientZoneGa(item.title)"
                            >
                                {{ item.title }}
                            </span>
                        </PlusBlogLpAtomAccordionTrigger>
                        <PlusBlogLpAtomAccordionContent>
                            <li
                                v-for="(link, index) in item.content"
                                :key="index"
                                class="text-grey-200 list-none py-3 font-figtree"
                                @click="sendChildGa(link, item.title)"
                            >
                                <PlusBlogLpAtomLink
                                    :link="link.link"
                                    :value="link.name"
                                />
                            </li>
                        </PlusBlogLpAtomAccordionContent>
                    </PlusBlogLpAtomAccordionItem>
                </PlusBlogLpAtomAccordion>
                <div
                    v-for="(link, index) in links"
                    :key="index"
                    class="hidden xl:flex xl:w-[288px]"
                >
                    <div class="flex w-full flex-col">
                        <h5
                            class="heading-xs text-grey-200 xl:label-md mb-2 py-2.5 font-bold"
                            @click="sendFormGa(link)"
                            v-html="link.name"
                        />
                        <ul>
                            <li
                                v-for="(item, index) in link.items"
                                :key="index"
                                class="pb-4 text-gray-200"
                                @click="sendChildGa(item, link.name)"
                            >
                                <PlusBlogLpAtomLink
                                    :link="item.link"
                                    :value="item.name"
                                    light-mode
                                />
                            </li>
                        </ul>
                    </div>
                </div>
                <hr
                    size="1"
                    width="100%"
                    noshade
                    class="text-brand-darkblue-300 xl:hidden"
                />

                <div class="flex xl:w-[288px]">
                    <div class="flex w-full flex-col font-figtree">
                        <ul>
                            <li
                                v-for="(item, index) in contact"
                                :key="index"
                                class="mb-3 w-full pt-1 font-bold text-gray-200"
                                @click="sendFormGa(item)"
                            >
                                <PlusBlogLpAtomLink
                                    :link="item.link"
                                    :value="item.name"
                                    bigger
                                    light-mode
                                />
                            </li>
                            <a
                                id="ot-sdk-btn"
                                href="#"
                                class="ot-sdk-show-settings"
                            >
                                Ustawienia
                            </a>
                        </ul>
                    </div>
                </div>
            </div>
            <hr
                size="1"
                width="100%"
                noshade
                class="text-plus-lp-brand-dark-blue-300"
            />
            <div class="mt-8 flex flex-col gap-2 text-lp-label-xs text-plus-lp-grey-300 xl:mt-6">
                <span
                    v-for="(item, index) in footerCopy"
                    :key="index"
                >
                    {{ item }}
                </span>
            </div>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
#ot-sdk-btn.ot-sdk-show-settings {
    @apply border-0 bg-inherit text-white p-0 font-bold lp-paragraph-lg-bold relative before:absolute before:bottom-0 before:left-0 before:block before:h-px before:w-full before:origin-left before:scale-x-0 before:transition-transform before:duration-300 before:ease-out before:content-[''] before:bg-white before:hover:scale-x-100;
}
</style>
